/**
 * krv/PdfVorschau – PDF rechts neben der Tabelle (Welle 96).
 *
 * Lädt die Datei über den normalen API-Aufruf (der globale fetch hängt den
 * Login-Token an) und zeigt sie als Blob im eingebauten PDF-Viewer des Browsers —
 * Zoom, Seiten und Drucken gibt es dadurch ohne eigene Bedienelemente.
 */
import React, { useEffect, useState } from "react";
import { FaExternalLinkAlt, FaTimes } from "react-icons/fa";
import { API, S, IconKnopf } from "./gemeinsam";

export default function PdfVorschau({ beleg, onSchliessen }) {
  const [url, setUrl] = useState(null);
  const [fehler, setFehler] = useState("");

  useEffect(() => {
    let abgebrochen = false;
    let blobUrl = null;
    setUrl(null); setFehler("");
    fetch(`${API}/belege/${beleg.id}/datei`)
      .then(async (r) => {
        if (!r.ok) {
          const t = await r.text();
          let d = t; try { d = JSON.parse(t).detail || t; } catch (_) { /* Text */ }
          throw new Error(d || r.statusText);
        }
        return r.blob();
      })
      .then((b) => {
        if (abgebrochen) return;
        blobUrl = URL.createObjectURL(new Blob([b], { type: "application/pdf" }));
        setUrl(blobUrl);
      })
      .catch((e) => { if (!abgebrochen) setFehler(String(e.message || e)); });
    return () => { abgebrochen = true; if (blobUrl) URL.revokeObjectURL(blobUrl); };
  }, [beleg.id]);

  return (
    <div style={S.vorschau}>
      <div style={S.vorschauKopf}>
        <span style={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis",
                       whiteSpace: "nowrap", fontSize: "0.82rem", fontWeight: 600 }}
              title={beleg.datei_name}>
          {beleg.datei_name}
        </span>
        <span style={{ fontSize: "0.72rem", color: "var(--color-gray-500)", whiteSpace: "nowrap" }}>
          ↑ ↓ blättern
        </span>
        <IconKnopf farbe="blau" titel="In neuem Tab öffnen" disabled={!url}
                   onClick={() => url && window.open(url, "_blank")}>
          <FaExternalLinkAlt />
        </IconKnopf>
        <IconKnopf farbe="grau" titel="Vorschau schließen (Esc)" onClick={onSchliessen}>
          <FaTimes />
        </IconKnopf>
      </div>
      {fehler && <div style={{ ...S.err, margin: 10 }}>{fehler}</div>}
      {!url && !fehler && (
        <div style={{ padding: 20, fontSize: "0.85rem", color: "var(--color-gray-500)" }}>Lade PDF…</div>
      )}
      {url && <iframe title="PDF-Vorschau" src={url} style={S.vorschauRahmen} />}
    </div>
  );
}
